import service from '@api/config'

// 首页个人信息
export const userIndex = (data) => {
  return service.request({
    url: `/user/index`,
    method: 'post',
    data: data
  })
}

// 信息列表
export const indexInfos = (data) => {
  return service.request({
    url: `/index/infos`,
    method: 'post',
    data: data
  })
}

// 推荐信息
export const recommends = (data) => {
  return service.request({
    url: `/index/recommends`,
    method: 'post',
    data: data
  })
}

// 待办事项
export const indexTodo = (data) => {
  return service.request({
    url: `/index/todo`,
    method: 'post',
    data: data
  })
}

// 更换头像
export const updateHeadImg = (data) => {
  return service.request({
    url: `/user/updateHeadImg`,
    method: 'post',
    data: data
  })
}

//
export const companyText = (params) => {
  return service.request({
    url: `/company/text/img`,
    method: 'get',
    params: params
  })
}

// 获取学习培训和保障服务
export const contentsList = (data) => {
  return service.request({
    url: `/index/contents`,
    method: 'post',
    data: data
  })
}
// 内容列表
export const contentList = (data) => {
  return service.request({
    url: `/index/contentList`,
    method: 'post',
    data: data
  })
}

// 内容详情
export const contentDetail = (data) => {
  return service.request({
    url: `/index/contentDetail`,
    method: 'post',
    data: data
  })
}

// 获取登录验证码
export const sendLoginCode = (data) => {
  return service.request({
    url: `/login/sendLoginCode`,
    method: 'post',
    data: data
  })
}

// 登录
export const login = (data) => {
  return service.request({
    url: `/login/accessCodeByPhone`,
    method: 'post',
    data: data
  })
}

//  获取codeinstall地址
export const codeInstall = (data) => {
  return service.request({
    url: `/data/codeinstall`,
    method: 'post',
    data: data
  })
}

//  获取微信小程序码
export const getWxXcxQrCode = (data) => {
  return service.request({
    url: `/wx/createQRCode`,
    method: 'post',
    data: data
  })
}

//  判断是否已实名
export const isAuth = (data) => {
  return service.request({
    url: `/company/isAuth`,
    method: 'post',
    data: data
  })
}

//  判断是否已实名
export const isAuthData = (data) => {
  return service.request({
    url: `/user/isAuth`,
    method: 'post',
    data: data
  })
}
